export default "__VITE_ASSET__VmLqD1u1__"